<template>
  <div class="default-page-wrapper">
    <slot />
    <FooterElement/>
  </div>
</template>

<script>
import FooterElement from '../components/navigation/Footer.vue';
export default {
  components: {
    FooterElement
  }
}
</script>

<style lang="scss">
</style>